import type { FormData, EvaluationType_Option } from "./types";

export const formatDate = (dateString: string): string => {
  if (!dateString) return "___/___/______";
  const date = new Date(dateString + "T00:00:00");
  return date.toLocaleDateString("pt-BR");
};

export const getEvaluationTypeLabel = (
  typeId: string,
  types: EvaluationType_Option[],
): string => {
  return types.find((t) => t.id === typeId)?.label || typeId;
};

export const validateFormData = (formData: FormData): boolean => {
  return !!(formData.subject && formData.class && formData.title);
};

export const buildN8nPayload = (
  formData: FormData,
  types: EvaluationType_Option[],
) => {
  return {
    disciplina: formData.subject,
    serie: formData.class,
    tema: formData.title,
    tipo_avaliacao: getEvaluationTypeLabel(formData.type, types),
    peso: formData.weight,
    objetivo: `Criar uma ${getEvaluationTypeLabel(formData.type, types)} sobre ${formData.title} para alunos do ${formData.class}`,
    informacoes_adicionais: formData.additionalInfo || "",
    conteudo_pdf: formData.pdfText || "",
    numero_questoes: formData.numberOfQuestions || "5",
    dificuldade: formData.difficulty || "medium",
    instrucoes_customizadas: formData.customPrompt || "",
    origem: "evaluation_creator",
    // Values from QuestionsDistributionSection
    objetivas: formData.objetivas || 0,
    dissertativas: formData.dissertativas || 0,
  };
};
